import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transferService from "./transferService";

const initialState = {
  transfer: {},
  transfers: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// Create transfer
export const createTransfer = createAsyncThunk(
  "resellerTransfers/create",
  async (transferData, thunkAPI) => {
    try {
      return await transferService.createTransfer(transferData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get transfers
export const getTransfers = createAsyncThunk(
  "resellerTransfers/getAll",
  async (data, thunkAPI) => {
    try {
      return await transferService.getTransfers(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const transfersSlice = createSlice({
  name: "resellerTransfers",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      state.transfer = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTransfer.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.message = "";
      })
      .addCase(createTransfer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.transfer = action.payload;
      })
      .addCase(createTransfer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
  },
});

export const { reset } = transfersSlice.actions;
export default transfersSlice.reducer; 